// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.MyCustomHits { width: 1000px; }*/

.App {
  text-align: left;
}
/* 
  a.ais-ToggleRefinement-list
  {
  color: red;
  } */

/* a.ais-Pagination-link {
    background-color: white;
    border: 1px solid #eee;
    color: #555;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  } */

a.ais-Pagination-link:hover {
  color: grey;
}

/* .ais-Pagination-item--selected a.ais-Pagination-link {
    color: #fff;
    background-color: #5bc2a8;
    border-color: #5bc2a8;
  } */

.ais-SearchBox {
  margin: 1em 0;
}
.ais-Pagination {
  margin-top: 1em;
}

/* .ais-Hits-item { color: teal} */

/* li.ais-Hits-item{
  width: 950px;
  } */

/* .ais-ToggleRefinement
  {
  color: white;
  } */

.ais-Hits-list {
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.pagination {
  display: flex;
  justify-content: left;
}
/* 
  .slider-teal
  {
  color:hotpink;
  background-color: hotpink;
  }
  
  .left-panel
  {
  width: 200px;
  } */

/* .filter-pink
  {
  color:white;
  font-family: Times;
  font-size: 15px;
  background-color: pink;
  border-radius: 5px;
  } */

/* .hit-description { color: teal; font-size: 14px;} */

/* .hit {
  color:teal;
  font-family: Times;
  font-size: 15px;
  background-color: white;
  border-radius: 5px;
  } */

.flex-container {
  display: flex;
}

.flex-container-pagination {
  display: flex;
  flex-direction: column;
  width: 860px;
}

.ais-Pagination {
  width: 100%;
  margin-bottom: 2em;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0%;
  z-index: 999;
  padding: 1em;
  background-color: white;
}

.ais-Pagination-item + .ais-Pagination-item {
  border: 1px solid #14967b;
}

.ais-Pagination-item--selected a.ais-Pagination-link {
  color: #fff;
  background-color: #5bc2a8;
  border-color: #5bc2a8;
}

.ais-Pagination
  .ais-Pagination-item.ais-Pagination-item--selected.ais-Pagination-item--page {
  display: inherit;
}

/* .ais-Pagination-link{
    font-size: 20px !important;
    border-radius: 5px !important;
    
  } */
.ais-Pagination-item--firstPage {
  display: none;
}

.ais-Pagination-item a.ais-Pagination-link {
  font-size: 15px;
  border-radius: 0;
  border: none;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ais-Pagination .ais-Pagination-list {
  justify-content: space-around;
}

/* .ais-Pagination-item--page{
    display: none;
  } */

.ais-Pagination-item--previousPage {
  position: relative;
  border: none !important;
}
.ais-Pagination-item--previousPage a {
  font-size: 2rem !important;
  box-shadow: none !important;
}
.ais-Pagination-item--previousPage span {
  font-size: 2rem !important;
  box-shadow: none !important;
}

.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {
  font-size: 15px;
  border: none;
  border-radius: 0;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .ais-Pagination-item--previousPage::after{
    content: 'Previous';
    position: absolute;
    bottom: 10px;
    left: 50px;
    color: #14967b;
  } */
.ais-Pagination-item--nextPage {
  position: relative;
  border: none !important;
}
.ais-Pagination-item--nextPage a {
  font-size: 2rem !important;
  box-shadow: none !important;
}

/* .ais-Pagination-item--nextPage::after{
    content: 'Next';
    position: absolute;
    bottom: 10px;
    left: -45px;
    color: #14967b;
  } */
`, "",{"version":3,"sources":["webpack://./src/views/jobs/Hits.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,gBAAgB;AAClB;AACA;;;;KAIK;;AAEL;;;;;KAKK;;AAEL;EACE,WAAW;AACb;;AAEA;;;;KAIK;;AAEL;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;;KAEK;;AAEL;;;KAGK;;AAEL;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;;;;;;;;;;KAUK;;AAEL;;;;;;;KAOK;;AAEL,sDAAsD;;AAEtD;;;;;;KAMK;;AAEL;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAgB;EAAhB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;KAIK;AACL;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;KAEK;;AAEL;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;KAMK;AACL;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;;;KAMK","sourcesContent":["/*.MyCustomHits { width: 1000px; }*/\n\n.App {\n  text-align: left;\n}\n/* \n  a.ais-ToggleRefinement-list\n  {\n  color: red;\n  } */\n\n/* a.ais-Pagination-link {\n    background-color: white;\n    border: 1px solid #eee;\n    color: #555;\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);\n  } */\n\na.ais-Pagination-link:hover {\n  color: grey;\n}\n\n/* .ais-Pagination-item--selected a.ais-Pagination-link {\n    color: #fff;\n    background-color: #5bc2a8;\n    border-color: #5bc2a8;\n  } */\n\n.ais-SearchBox {\n  margin: 1em 0;\n}\n.ais-Pagination {\n  margin-top: 1em;\n}\n\n/* .ais-Hits-item { color: teal} */\n\n/* li.ais-Hits-item{\n  width: 950px;\n  } */\n\n/* .ais-ToggleRefinement\n  {\n  color: white;\n  } */\n\n.ais-Hits-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n}\n\n.pagination {\n  display: flex;\n  justify-content: left;\n}\n/* \n  .slider-teal\n  {\n  color:hotpink;\n  background-color: hotpink;\n  }\n  \n  .left-panel\n  {\n  width: 200px;\n  } */\n\n/* .filter-pink\n  {\n  color:white;\n  font-family: Times;\n  font-size: 15px;\n  background-color: pink;\n  border-radius: 5px;\n  } */\n\n/* .hit-description { color: teal; font-size: 14px;} */\n\n/* .hit {\n  color:teal;\n  font-family: Times;\n  font-size: 15px;\n  background-color: white;\n  border-radius: 5px;\n  } */\n\n.flex-container {\n  display: flex;\n}\n\n.flex-container-pagination {\n  display: flex;\n  flex-direction: column;\n  width: 860px;\n}\n\n.ais-Pagination {\n  width: 100%;\n  margin-bottom: 2em;\n  position: sticky;\n  bottom: 0%;\n  z-index: 999;\n  padding: 1em;\n  background-color: white;\n}\n\n.ais-Pagination-item + .ais-Pagination-item {\n  border: 1px solid #14967b;\n}\n\n.ais-Pagination-item--selected a.ais-Pagination-link {\n  color: #fff;\n  background-color: #5bc2a8;\n  border-color: #5bc2a8;\n}\n\n.ais-Pagination\n  .ais-Pagination-item.ais-Pagination-item--selected.ais-Pagination-item--page {\n  display: inherit;\n}\n\n/* .ais-Pagination-link{\n    font-size: 20px !important;\n    border-radius: 5px !important;\n    \n  } */\n.ais-Pagination-item--firstPage {\n  display: none;\n}\n\n.ais-Pagination-item a.ais-Pagination-link {\n  font-size: 15px;\n  border-radius: 0;\n  border: none;\n  height: 25px;\n  width: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ais-Pagination .ais-Pagination-list {\n  justify-content: space-around;\n}\n\n/* .ais-Pagination-item--page{\n    display: none;\n  } */\n\n.ais-Pagination-item--previousPage {\n  position: relative;\n  border: none !important;\n}\n.ais-Pagination-item--previousPage a {\n  font-size: 2rem !important;\n  box-shadow: none !important;\n}\n.ais-Pagination-item--previousPage span {\n  font-size: 2rem !important;\n  box-shadow: none !important;\n}\n\n.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {\n  font-size: 15px;\n  border: none;\n  border-radius: 0;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .ais-Pagination-item--previousPage::after{\n    content: 'Previous';\n    position: absolute;\n    bottom: 10px;\n    left: 50px;\n    color: #14967b;\n  } */\n.ais-Pagination-item--nextPage {\n  position: relative;\n  border: none !important;\n}\n.ais-Pagination-item--nextPage a {\n  font-size: 2rem !important;\n  box-shadow: none !important;\n}\n\n/* .ais-Pagination-item--nextPage::after{\n    content: 'Next';\n    position: absolute;\n    bottom: 10px;\n    left: -45px;\n    color: #14967b;\n  } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
